var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: { "content-type--items-is-dragging": _setup.isDragging } },
    [
      _setup.items.length
        ? _c(
            _setup.draggable,
            _vm._b(
              {
                attrs: {
                  direction: "vertical",
                  draggable: "[data-draggable-item]",
                },
                on: {
                  end: _setup.onDragEnd,
                  start: function ($event) {
                    _setup.isDragging = true
                  },
                },
                model: {
                  value: _setup.items,
                  callback: function ($$v) {
                    _setup.items = $$v
                  },
                  expression: "items",
                },
              },
              "draggable",
              _setup.dragOptions,
              false
            ),
            [
              _c(
                "transition-group",
                {
                  staticClass: "overflow-hidden",
                  attrs: { type: "transition" },
                },
                _vm._l(_setup.items, function (item) {
                  return _c(
                    _setup.Button,
                    {
                      key: item.id,
                      ref: "contentTypeItem",
                      refInFor: true,
                      staticClass:
                        "ps-0 btn-sm w-100 d-flex align-items-top text-start",
                      attrs: {
                        disabled: _setup.ajaxInProgress,
                        "active-class": "btn-primary",
                        "active-value": item.id === _setup.selectedId,
                        "data-draggable-item": "",
                        draggable: "true",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _setup.editItem(item.id)
                        },
                      },
                    },
                    [
                      _c(_setup.DragHandle, {
                        staticClass: "content-type--item-drag-handle",
                      }),
                      _vm._v(" "),
                      _c(_setup.FieldTypeIcon, {
                        staticClass: "me-2",
                        attrs: { type: item.type },
                      }),
                      _vm._v(
                        "\n\n                " +
                          _vm._s(item.title) +
                          "\n            "
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }